import { IdentificationType } from "@/types/confirmation-types";

/* eslint-disable no-param-reassign */
export function rearrangeDateFormat(originalDate: string | undefined) {
  if (!originalDate) return "";
  return originalDate.split("-").reverse().join("/");
}

// export function rearrangeDateFormat = useCallback(
//       (originalDate: string | undefined) => {
//         if (!originalDate) return "";
//         return originalDate.split("-").reverse().join("/");
//       },
//       []
//     );

export function formatTelephoneNumber(telephoneNumber: string | undefined) {
  if (telephoneNumber) {
    telephoneNumber = telephoneNumber.replace(/\s/g, "");

    if (telephoneNumber.length === 11) {
      telephoneNumber = telephoneNumber.replace(/^(\d{5})(\d{6})/, "$1 $2");
    } else if (telephoneNumber.length === 13) {
      telephoneNumber = telephoneNumber.replace(/^(\d{6})(\d{7})/, "$1 $2");
    }
  }
  return telephoneNumber;
}

export const getIdentificationLabel = (type: IdentificationType): string => {
  switch (type) {
    case "PASSPORT":
      return "identification_type_passport";

    case "DNI":
      return "identification_type_dni";

    case "NIE":
      return "identification_type_nie";

    default:
      return "";
  }
};
